// libraries
import { withRouter } from 'react-router';
import connect from 'react-redux/es/connect/connect';
// actions
import { resendInvite } from 'state/actions/accountState/account_data';
// component
import ExpiredLinkPage from 'pages/auth/expiredlink/expiredlink';



/* ========== ~~~~~~~~~~ AUTH EXPIRED LINK : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ authStatus }) => ({
    tokenData: authStatus.tokenData
});
// map actions
const mapDispatchToProps = dispatch => ({
resendInvite: (userUUID,isResend, succRoute) => dispatch(resendInvite(userUUID, isResend, succRoute))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ExpiredLinkPage));
